import type { TrialReminderGroup } from './features/multi-page/lib/trial-reminder'
import { Loading } from './lib/loading'
import type { ServiceLevelStatus } from './types/service-level'

export const pageVisibleOnce = new Loading<void>()

export const serviceLevelStatusReady = new Loading<ServiceLevelStatus>()

export const regionReady = new Loading<string | null>()

/** Native's arm for the trial reminder experiment; only the reminder page waits on it. */
export const trialReminderGroupReady = new Loading<TrialReminderGroup>()
